export default "__VITE_ASSET__BalJkWhB__"